import http from './httpService'

export default class AbstractService {
    endpoint = '';

    http = http;

    constructor() {
      this.http = http
    }

    /**
     * get all resource data
     */
    index() {

    }
}
